import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Fix: Import LanguageProvider to ensure context is available for all sub-components
import { LanguageProvider } from './contexts/LanguageContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {/* Fix: Wrap App in LanguageProvider to avoid 'useLanguage must be used within a LanguageProvider' errors */}
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
